import React from "react";
import { useTranslation } from "react-i18next";
import { useAdminTenantId } from "../../hooks/useAdminTenantId";

type AdminTenantGuardProps = {
  children: React.ReactNode;
};

export const AdminTenantGuard = ({
  children,
}: AdminTenantGuardProps): React.JSX.Element => {
  const { t } = useTranslation();
  const tenantId = useAdminTenantId();

  if (!tenantId) {
    return (
      <p className="text-zinc-500">
        {t("analytics.admin.noTenant", "Tenant is not selected.")}
      </p>
    );
  }

  return <>{children}</>;
};
